// Bake the CPU ramp into an RGBA8 1D texture so the WebGL renderer can
// evaluate the gradient per fragment. Texel 256*k (or (W-1)/m*k) lands
// exactly on stop k, so hard mode fetches exact stop colours.
import type { RGB } from '../types.ts';
import { sampleRamp } from './ramp.ts';

export interface BakedRamp {
  rgba: Uint8Array;
  width: number;
  m: number;            // closedStops.length - 1
}

export function bakeRamp(closedStops: RGB[], maxWidth: number): BakedRamp {
  const m = Math.max(1, closedStops.length - 1);
  let perSpan = 256;
  if (perSpan * m + 1 > maxWidth) perSpan = Math.max(1, Math.floor((maxWidth - 1) / m));
  const width = perSpan * m + 1;
  const rgba = new Uint8Array(width * 4);
  for (let i = 0; i < width; i++) {
    const c = sampleRamp(closedStops, i / (width - 1));
    rgba[i * 4] = Math.round(c[0]);
    rgba[i * 4 + 1] = Math.round(c[1]);
    rgba[i * 4 + 2] = Math.round(c[2]);
    rgba[i * 4 + 3] = 255;
  }
  return { rgba, width, m };
}
